import { useState, useEffect } from "react";
import { emitKeyDown, emitKeyUp } from "../../../events/piano-events";
import { isPianoPointerDown, setPianoPointerDown } from "../../../events/piano-drag";
import { EVENTS } from "../../../events/events";
import "./upper-row-button.css";

type UpperRowNumber = 1 | 2 | 3 | 4 | 5;

export const UpperRowButton = ({ octaveNumber, upperRowButtonNumber }: { octaveNumber: number, upperRowButtonNumber: UpperRowNumber }) => {

  const notes = {
    1: "C",
    2: "D",
    3: "F",
    4: "G",
    5: "A"
  };

  const constructedSharpNote = notes[upperRowButtonNumber] + `#${octaveNumber}`;
  const [isActive, setIsActive] = useState(false);

  useEffect(() => {
    const onNoteOn = (e: Event) => { if ((e as CustomEvent).detail === constructedSharpNote) setIsActive(true); };
    const onNoteOff = (e: Event) => { if ((e as CustomEvent).detail === constructedSharpNote) setIsActive(false); };
    const onStopped = () => setIsActive(false);
    window.addEventListener(EVENTS.COMPOSER_NOTE_ON, onNoteOn);
    window.addEventListener(EVENTS.COMPOSER_NOTE_OFF, onNoteOff);
    window.addEventListener(EVENTS.COMPOSER_STOPPED, onStopped);
    window.addEventListener(EVENTS.PIANO_KEY_DOWN, onNoteOn);
    window.addEventListener(EVENTS.PIANO_KEY_UP, onNoteOff);
    return () => {
      window.removeEventListener(EVENTS.COMPOSER_NOTE_ON, onNoteOn);
      window.removeEventListener(EVENTS.COMPOSER_NOTE_OFF, onNoteOff);
      window.removeEventListener(EVENTS.COMPOSER_STOPPED, onStopped);
      window.removeEventListener(EVENTS.PIANO_KEY_DOWN, onNoteOn);
      window.removeEventListener(EVENTS.PIANO_KEY_UP, onNoteOff);
    };
  }, [constructedSharpNote]);

  return <button
    onPointerDown={() => { setPianoPointerDown(true); emitKeyDown(constructedSharpNote); }}
    onPointerUp={() => { setPianoPointerDown(false); emitKeyUp(constructedSharpNote); }}
    onPointerLeave={() => { emitKeyUp(constructedSharpNote); }}
    onPointerEnter={() => { if (isPianoPointerDown()) emitKeyDown(constructedSharpNote); }}
    className={`sk-octave-upper-row sk-upper-key-${upperRowButtonNumber}${isActive ? ' sk-key-active' : ''}`}
  ></button>
}